import GameModel from "../../../../vendor_core/core/src/model/GameModel";
import ISpinData from "../../../../vendor_core/core/src/server/data/ISpinData";
import { IBaseDataParser } from "../../../../vendor_core/core/src/server/parsers/IBaseDataParser";
import ConsoleUtil from "../../../../vendor_core/core/src/utils/ConsoleUtil";
import SymbolMap from "../../../../vendor_core/core/src/utils/SymbolMap";
import { ISpinResponseData } from "../data/ISpinResponseData";
// import * as test from "./resp.json"


export default class BBReelConfigParser implements IBaseDataParser<ISpinData> {
    check(data: any): boolean {
        return data && data.refresh && data.config;
    }
    parse(data): ISpinData[] {
        // data = test
        const refresh = data.refresh as ISpinResponseData;
        for (const sym in refresh.stackReplacements) {
            SymbolMap.setSymbolIdMask(
                sym,
                SymbolMap.getSymbolId(refresh.stackReplacements[sym])
            );
        }

        if (refresh.bonusReel) {
            data.config.grids.baseReels.reels.push(refresh.bonusReel);
            data.config.grids.freeSpinReels.reels.push(refresh.bonusReel);
        }

        const result = {
            winAmount: refresh.win,
            reelHeight: refresh.reelheight,
            ended: refresh.ended, // round ended
            stopPositions: refresh.stops, // reel stop position
            reelStopSymbols: SymbolMap.parseSymbols(refresh.generations[refresh.generations.length - 1].symbols),
            reelFinalSymbols: SymbolMap.parseSymbols(refresh.generations[refresh.generations.length - 1].symbols),
            // reelSets: [
            //     data.config.grids.baseReels.reels,
            //     data.config.grids.freeSpinReels.reels,
            // ],
            reelSetIndex: GameModel.gameConfig.reelSetsMap[refresh.grid],
        };

        ConsoleUtil.log("[SBoReelConfigParser] Result", result);

        return [result];
    }
}
